module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_amazon-7a3c066519dc8e7584550d3f6ef6999c.png";